import { useSelector } from 'react-redux';

export const useMe = () => {
  return useSelector(({ user }) => user.me);
};
